export const SET_JOBS = "SET_JOBS";
export const SET_JOB_DETAILS = "SET_JOB_DETAILS";